import { React, FelaComponent } from '../../dependencies';

import * as styles from './TopOffset.styles';

export default function TopOffset() {
    return <FelaComponent style={styles.topOffset} />;
}
